// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KU4Vn","logo":"Header_logo__eZ70R","closeBurger":"Header_closeBurger__Xx5RX"};